var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopTransferImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 128,
    viewBox: "0 0 162 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4831 0C40.9078 0 8.01367 32.9035 8.01367 73.4905C8.01367 84.3028 10.3665 94.5602 14.5598 103.805H148.406C152.6 94.5602 154.952 84.3028 154.952 73.4905C154.952 32.9035 122.058 0 81.4831 0Z",
    fill: "#05C3DE",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26562 103.641H152.531",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 103.641H5.59184",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.204 103.641H160.796",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.136 124.23C111.136 125.829 98.1833 127.124 82.2074 127.124C66.2296 127.124 53.2788 125.829 53.2788 124.23C53.2788 122.632 66.2296 121.336 82.2074 121.336C98.1833 121.336 111.136 122.632 111.136 124.23Z",
    fill: "#E6F9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.755 100.669L117.747 63.6281C117.747 61.0724 115.676 59 113.119 59H50.6404C48.0855 59 46.0137 61.0724 46.0137 63.6281L46.021 100.669H117.755Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5931 100.767L97.2484 59.0977H50.9627C48.4078 59.0977 46.3359 61.1701 46.3359 63.7257L46.3433 100.767H55.5931Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.071 100.766V110.025C118.071 112.583 115.999 114.655 113.44 114.655H50.9636C48.4088 114.655 46.3369 112.583 46.3369 110.025V100.766H118.071Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.071 100.766V110.025C118.071 112.583 115.999 114.655 113.44 114.655H50.9636C48.4088 114.655 46.3369 112.583 46.3369 110.025V100.766H118.071Z",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5211 107.709C84.5211 108.988 83.4871 110.024 82.2069 110.024C80.9285 110.024 79.8926 108.988 79.8926 107.709C79.8926 106.432 80.9285 105.394 82.2069 105.394C83.4871 105.394 84.5211 106.432 84.5211 107.709Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5211 107.709C84.5211 108.988 83.4871 110.024 82.2069 110.024C80.9285 110.024 79.8926 108.988 79.8926 107.709C79.8926 106.432 80.9285 105.394 82.2069 105.394C83.4871 105.394 84.5211 106.432 84.5211 107.709Z",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7786 123.916H70.6357L71.7929 114.656H92.6215L93.7786 123.916Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7786 123.916H70.6357L71.7929 114.656H92.6215L93.7786 123.916Z",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6938 123.915H100.721",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.077 100.767L118.07 63.7257C118.07 61.1701 115.998 59.0977 113.441 59.0977H50.9627C48.4078 59.0977 46.3359 61.1701 46.3359 63.7257L46.3433 100.767H118.077Z",
    stroke: "#054C70",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0941 79.9316C96.0941 87.6022 89.8749 93.8213 82.2065 93.8213C74.5381 93.8213 68.3208 87.6022 68.3208 79.9316C68.3208 72.2592 74.5381 66.04 82.2065 66.04C89.8749 66.04 96.0941 72.2592 96.0941 79.9316Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0284 23.1352L101.067 23.2766",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8169 14.6492L100.826 23.05L92.1528 32.3506",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.999 43.1352L61.9602 43.2766",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2104 34.6492L62.2016 43.05L70.8745 52.3506",
    stroke: "#05C3DE",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.935 94.87C89.6311 94.87 95.87 88.6311 95.87 80.935C95.87 73.2389 89.6311 67 81.935 67C74.2389 67 68 73.2389 68 80.935C68 88.6311 74.2389 94.87 81.935 94.87Z",
    fill: "white",
    stroke: "#054C70"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.381 72.4908L91.6704 90.244",
    stroke: "#054C70",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTransferImage);
export default __webpack_public_path__ + "static/media/StopTransferImage.3266cb3dea1c9a9e23dfecf82290d0da.svg";
export { ForwardRef as ReactComponent };